var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePeapDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    id: "clip0_28_14675",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "none",
    strokeLinejoin: "none",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51657,12.2248c0.06121,0.8165 0.68187,1.4924 1.48892,1.6311c0.83952,0.1443 1.70596,0.2828 2.59188,0.2828c0.88595,0 1.75238,-0.1385 2.5919,-0.2828c0.80705,-0.1387 1.42771,-0.8146 1.48891,-1.6311c0.10884,-1.452 0.23045,-2.96224 0.23045,-4.51262c0,-1.55039 -0.12161,-3.06059 -0.23045,-4.51259c-0.0612,-0.81658 -0.68186,-1.49245 -1.48891,-1.63114c-0.83952,-0.14427 -1.70595,-0.28281 -2.5919,-0.28281c-0.88592,0 -1.75236,0.13854 -2.59188,0.28281c-0.80705,0.13869 -1.42771,0.81456 -1.48892,1.63114c-0.10884,1.452 -0.23044,2.9622 -0.23044,4.51259c0,1.55038 0.12161,3.06062 0.23044,4.51262z",
    stroke: "#4a57da",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3222,20.8004c0.0612,0.8167 0.6819,1.4924 1.489,1.6311c0.8395,0.1444 1.7059,0.2829 2.5918,0.2829c0.886,0 1.7524,-0.1385 2.5919,-0.2829c0.8071,-0.1387 1.4278,-0.8144 1.489,-1.6311c0.1088,-1.452 0.2304,-2.9621 0.2304,-4.5125c0,-1.5504 -0.1216,-3.0606 -0.2304,-4.5126c-0.0612,-0.8166 -0.6819,-1.4925 -1.489,-1.6312c-0.8395,-0.14424 -1.7059,-0.28277 -2.5919,-0.28277c-0.8859,0 -1.7523,0.13853 -2.5918,0.28277c-0.8071,0.1387 -1.4278,0.8146 -1.489,1.6312c-0.1088,1.452 -0.2304,2.9622 -0.2304,4.5126c0,1.5504 0.1216,3.0605 0.2304,4.5125z",
    stroke: "#4a57da",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1557,4.30906c0.1237,0.79426 0.8358,1.38002 1.6382,1.42891c0.8449,0.05148 1.7172,0.10125 2.6091,0.10125c0.892,0 1.7644,-0.04975 2.6092,-0.10125c0.8024,-0.04889 1.5146,-0.63465 1.6383,-1.42891c0.0383,-0.24547 0.0638,-0.49455 0.0638,-0.74664c0,-0.25207 -0.0255,-0.50115 -0.0638,-0.74662c-0.1237,-0.79426 -0.8359,-1.38001 -1.6383,-1.42891c-0.8448,-0.05149 -1.7172,-0.10125 -2.6092,-0.10125c-0.8919,0 -1.7642,0.04976 -2.6091,0.10125c-0.8024,0.0489 -1.5145,0.63465 -1.6382,1.42891c-0.0383,0.24547 -0.0639,0.49455 -0.0639,0.74662c0,0.25209 0.0256,0.50117 0.0639,0.74664z",
    stroke: "#4a57da",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34998,21.184c0.12372,0.7942 0.83586,1.38 1.63822,1.4288c0.84492,0.0516 1.71716,0.1013 2.60917,0.1013c0.89201,0 1.76428,-0.0497 2.60918,-0.1013c0.80235,-0.0488 1.5145,-0.6346 1.63822,-1.4288c0.03823,-0.2455 0.06386,-0.4946 0.06386,-0.7466c0,-0.2522 -0.02563,-0.5013 -0.06386,-0.7468c-0.12372,-0.7942 -0.83587,-1.38 -1.63822,-1.4288c-0.8449,-0.0514 -1.71717,-0.1012 -2.60918,-0.1012c-0.89201,0 -1.76425,0.0498 -2.60917,0.1012c-0.80236,0.0488 -1.5145,0.6346 -1.63822,1.4288c-0.03823,0.2455 -0.06385,0.4946 -0.06385,0.7468c0,0.252 0.02562,0.5011 0.06385,0.7466z",
    stroke: "#4a57da",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePeapDashboardIcon);
export default __webpack_public_path__ + "static/media/active-peap-dashboard-icon.8eb9804565250a14c5f04be517c2b358.svg";
export { ForwardRef as ReactComponent };